import {connect} from 'react-redux';
import AdministratorsPanel from './AdministratorsPanel.jsx';
import {
  handleAdministratorAddClick,
  handleAdministratorSaveClick,
  handleAdministratorCancelClick,
  handleAdministratorRemoveClick
} from './actions';

const mapStateToProps = state => ({
  administrators: state.tournament.permissions.administrators
});

const mapDispatchToProps = dispatch => ({
  onAddAdministratorClick: () => dispatch(handleAdministratorAddClick()),
  onSaveClick: id => dispatch(handleAdministratorSaveClick(id)),
  onCancelClick: () => dispatch(handleAdministratorCancelClick()),
  onRemoveClick: id => dispatch(handleAdministratorRemoveClick(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorsPanel);



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/AdministratorsPanelContainer.jsx